<template>
    <button @click="start" style="width: 50px; height: 50px; margin: 50px auto">开始录音</button>
</template>

<script>
import {getWxSingleConfig} from "@/js/wx";

export default {
    name: "test",
    created() {
        getWxSingleConfig().then(() => {

        });
    },
    methods: {
        start() {
            wx.startRecord({
                success: () => {
                    alert("录音中");
                    // setTimeout(() => {
                    //   this.clickRecord();
                    //   console.log("超出最长录制时间");
                    // }, 60000);
                    // setTimeout(() => {
                    //   this.BshowToast = true;
                    //   console.log('录音结束');
                    // }, 6000);
                },
                cancel: () => {
                    //alert("不允许");
                },
                complete: (e) => {
                    console.log(e);
                },
                fail: (res) => {
                    alert(JSON.stringify(res));
                },
            });
        }
    }
}
</script>

<style scoped>

</style>